const isEmail = (value) => {
  const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return !!regexEmail.test(value);
};

export default isEmail;
